import React from 'react';
import { CheckCircle2Icon, LockIcon, ShieldCheckIcon, DownloadIcon } from 'lucide-react';
import { trustItems } from '../data/content';
const icons = [LockIcon, CheckCircle2Icon, ShieldCheckIcon, DownloadIcon];
export function TrustRow({
  tone = 'light'
}: {
  tone?: 'light' | 'dark';
}) {
  return <ul className={`flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm font-medium ${tone === 'dark' ? 'text-cream/70' : 'text-ink-soft'}`} data-id="element-170" data-mp="2couvyqzq9bvp">
      {trustItems.map((t, i) => {
      const Icon = icons[i];
      return <li key={t} className="flex items-center gap-2" data-id="element-171" data-mp="1k20kgjkw1mud" data-mpi={i}>
            <Icon className={`h-4 w-4 ${tone === 'dark' ? 'text-terra-soft' : 'text-terra'}`} aria-hidden="true" data-id="element-172" data-mp="1yxpynvju0voj" />
            {t}
          </li>;
    })}
    </ul>;
}